module.exports = __webpack_public_path__ + "static/tiger_eye-eb00c3895343459efeff01aff63382a4.svg";